module.exports = __webpack_public_path__ + "static/media/header.3e98e34c.png";